// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorSubtleAccent, relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var inputStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  'input&': {
    backgroundColor: "var(--ds-background-input, white)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: "1px solid ".concat("var(--ds-border-input, ".concat(akEditorSubtleAccent, ")")),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    height: '40px',
    paddingLeft: "var(--ds-space-250, 20px)",
    paddingTop: "var(--ds-space-150, 12px)",
    paddingBottom: "var(--ds-space-150, 12px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: relativeFontSizeToBase16(14),
    width: '100%',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1.42857142857143,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: '-0.005em',
    color: "var(--ds-text-subtlest, #6B6E76)",
    '&:hover': {
      backgroundColor: "var(--ds-background-input-hovered, white)",
      borderColor: "var(--ds-border-input, #8C8F97)",
      cursor: 'text'
    }
  }
});